import dynamic from 'next/dynamic'

import {
  css,
  mq,
  spacing,
  styled,
  Text,
  zIndex,
  ZIndexLevel,
} from '@thg-commerce/enterprise-theme'
import { Button } from '@thg-commerce/gravity-elements'

export const ChevronRight = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ChevronRight'),
  { ssr: false },
)

export const ArrowLeft = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ArrowLeft'),
  { ssr: false },
)

export const ArrowRight = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/ArrowRight'),
  { ssr: false },
)

export const ChevronLeft = styled(ChevronRight)`
  transform: rotate(180deg);
`

const overlay = css<{ enableAlternateMobileFacet?: boolean }>`
  ${zIndex(ZIndexLevel.Highest)};
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 100%;
  height: 100%;
  padding: ${(props) =>
    props.enableAlternateMobileFacet
      ? `0 0 ${spacing(12)} 0`
      : `${spacing(3)} ${spacing(3)} ${spacing(11)} ${spacing(3)}`};
  background: ${(props) => props.theme.colors.palette.greys.white};
`

export const MobileFacetsContainer = styled.div<{
  showMobileFacets: boolean
  enableAlternateMobileFacet?: boolean
}>`
  ${overlay}

  visibility: hidden;
  top: 100%;
  left: 0;
  background-color: ${(props) =>
    props.enableAlternateMobileFacet
      ? props.theme.colors.palette.greys.lighter
      : 'none'};

  ${(props) =>
    props.showMobileFacets &&
    css`
      visibility: visible;
      top: 0;
      transition: top 0.5s ease;
    `}

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    display: none;
  }
`

export const FacetSectionContent = styled.div<{
  showFacetContent: boolean
  enableAlternateMobileFacet?: boolean
}>`
  ${overlay}

  top: 0;
  left: 100%;
  transition: left 0.5s ease, right 0.5s ease;

  ${(props) =>
    props.showFacetContent &&
    css`
      left: 0;
    `};
`
export const Header = styled.div<{ enableAlternateMobileFacet?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: ${(props) =>
    props.enableAlternateMobileFacet ? `${spacing(2)}` : '0px'};
  background-color: ${(props) =>
    props.enableAlternateMobileFacet
      ? props.theme.colors.palette.greys.lighter
      : 'none'};
`

const ButtonStyles = css<{ enableAlternateMobileFacet?: boolean }>`
  ${Text('bodyText', 'default')};
  display: flex;
  align-items: center;
  margin-left: -${spacing(0.5)};

  svg {
    margin: ${(props) =>
      props.enableAlternateMobileFacet
        ? `0 0 0 ${spacing(1)}`
        : `0 ${spacing(1)} 0 0`};
  }
`

export const BackButton = styled.button<{
  enableAlternateMobileFacet?: boolean
}>`
  ${ButtonStyles}
  touch-action: manipulation;
`

export const CloseButton = styled.button<{
  enableAlternateMobileFacet?: boolean
}>`
  ${ButtonStyles}
  order: ${(props) => (props.enableAlternateMobileFacet ? '2' : '0')};
  touch-action: manipulation;
`

export const ClearAllWrapper = styled.div<{
  enableAlternateMobileFacet?: boolean
}>`
  order: ${(props) => (props.enableAlternateMobileFacet ? '0' : '2')};
`

export const StyledTitle = styled.h2`
  ${Text('large1', 'alternate')};
  margin-top: ${spacing(5)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${spacing(8)};
  }

  @media (orientation: landscape) {
    margin-top: ${spacing(3)};
  }
`
export const StyledHeading = styled.h2`
  ${Text('large1', 'alternate')};
  flex-grow: 1;
  order: 1;
  text-align: center;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  margin-bottom: ${spacing(4)};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-bottom: ${spacing(6)};
  }
`

export const SelectedFacetsContainer = styled.div<{
  enableAlternateMobileFacet?: boolean
}>`
  margin-top: ${(props) =>
    props.enableAlternateMobileFacet ? '0px' : `${spacing(2)}`};
  padding-bottom: ${(props) =>
    props.enableAlternateMobileFacet ? `${spacing(1.25)}` : '0px'};

  ul {
    background-color: ${(props) =>
      props.enableAlternateMobileFacet
        ? props.theme.colors.palette.greys.white
        : 'none'};
    > li {
      margin-top: ${(props) =>
        props.enableAlternateMobileFacet ? '0px' : `${spacing(1)}`};
    }
  }
`

export const FacetSectionsContainer = styled.div<{
  enableAlternateMobileFacet?: boolean
}>`
  display: flex;
  flex-direction: column;
  margin-top: ${(props) =>
    props.enableAlternateMobileFacet ? '0px' : `${spacing(4)}`};
  background-color: ${(props) =>
    props.enableAlternateMobileFacet
      ? props.theme.colors.palette.greys.white
      : 'none'};

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    margin-top: ${(props) =>
      props.enableAlternateMobileFacet ? '0px' : `${spacing(6)}`};
  }

  @media (orientation: landscape) {
    margin-top: ${(props) =>
      props.enableAlternateMobileFacet ? '0px' : `${spacing(4)}`};
  }
`

export const SaveWrapper = styled.div<{
  enableAlternateMobileFacet?: boolean
}>`
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: ${(props) =>
    props.enableAlternateMobileFacet
      ? `${spacing(1)} ${spacing(2)} ${spacing(5)} ${spacing(2)}`
      : `0 ${spacing(3)} ${spacing(5)} ${spacing(3)}`};
  background: ${(props) => props.theme.colors.palette.greys.white};
  border-top: ${(props) =>
    props.enableAlternateMobileFacet
      ? `1px solid ${props.theme.colors.palette.greys.light}`
      : 'none'};
`

export const SaveButton = styled(Button)`
  height: 100%;
  width: 100%;
`

export const FacetTitleButton = styled.button<{
  enableAlternateMobileFacet?: boolean
}>`
  ${Text('bodyText', 'default')};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: ${spacing(2)};
  border-bottom: 1px solid ${(props) => props.theme.colors.palette.greys.light};

  svg {
    margin: ${(props) =>
      props.enableAlternateMobileFacet
        ? `0 0 0 ${spacing(1)}`
        : `0 ${spacing(1)} 0 0`};
  }

  &:not(:first-child) {
    padding: ${(props) =>
      props.enableAlternateMobileFacet
        ? `${spacing(2)}`
        : `${spacing(2)} 0 ${spacing(2)} 0`};
  }

  &:first-child {
    padding: ${(props) =>
      props.enableAlternateMobileFacet
        ? `${spacing(2)}`
        : `0 0 ${spacing(2)} 0`};
  }

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding-bottom: ${spacing(3)};

    &:not(:first-child) {
      padding-top: ${spacing(3)};
    }
  }

  touch-action: manipulation;
`

export const SectionCountWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const SectionCount = styled.span<{
  addTitleMargins?: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: ${(props) => props.theme.colors.palette.greys.white};
  background: ${(props) => props.theme.colors.palette.greys.darker};
  border-radius: 50%;
  font-size: 90%;
  margin-left: ${spacing(2)};

  ${(props) =>
    props.addTitleMargins &&
    css`
      margin-top: ${spacing(5)};

      ${mq(props.theme.breakpointUtils.map, 'sm')} {
        margin-top: ${spacing(8)};
      }

      @media (orientation: landscape) {
        margin-top: ${spacing(3)};
      }
    `}
  }
`
